import {baseAxios} from '../helper/axiosHelper';

export const creditorService = {
    getCreditors,
    insertCreditor,
    insertCreditorArticle,
    updateCreditor,
    updateCreditorArticle,
    deleteCreditor,
    deleteCreditorArticle,
    getCreditor,
    getCreditorArticles
};

function getCreditors() {

    return baseAxios.get('creditors/creditors/')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function getCreditorArticles(id) {

    return baseAxios.get('creditors/creditor/articles',{params:{id:id}})
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function insertCreditor(data) {

    return baseAxios.post('creditors/creditor/',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function insertCreditorArticle(data) {

    return baseAxios.post('creditors/creditor/article/',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function updateCreditor(data) {

    return baseAxios.put('creditors/creditor/',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function updateCreditorArticle(data) {

    return baseAxios.put('creditors/creditor/article/',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function deleteCreditor(id) {

    return baseAxios.delete('creditors/creditor/',{params:{id:id}})
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function deleteCreditorArticle(id) {

    return baseAxios.delete('creditors/creditor/article/',{params:{id:id}})
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function getCreditor(id) {

    return baseAxios.get('creditors/creditor/',{params:{id:id}})
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}


